import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=60bc5bec"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"
import style0 from "./schedule.vue?vue&type=style&index=0&id=60bc5bec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports